import { ExternalLink, Heart, Sparkles } from "lucide-react";
import { usePageMeta } from "@/hooks/usePageMeta";
import { PARTNERS, partnerOutUrl } from "@/data/partners";

export default function WeLove() {
  usePageMeta(
    "We Love — Recommended Beauty Sites | Beauty Trade Club",
    "A hand-picked list of beauty sites and partners the Beauty Trade Club community loves. Discover trusted brands, guides and resources.",
    "/we-love"
  );

  return (
    <div className="max-w-7xl mx-auto px-6 py-14" data-testid="we-love-page">
      <div className="text-center mb-12">
        <div className="flex items-center justify-center gap-2 text-[#E8956B] text-sm font-extrabold uppercase tracking-[0.3em] mb-4">
          <Heart size={16} fill="currentColor" /> We Love
        </div>
        <h1 className="font-display text-4xl sm:text-5xl font-black text-neutral-900 tracking-tight">
          Sites We <span className="text-[#E8956B]">Love</span>
        </h1>
        <p className="mt-4 text-base text-neutral-500 max-w-xl mx-auto">
          A hand-picked list of beauty brands, guides and partners our community
          loves. Tap any card to explore — they'll open in a new tab so Beauty
          Trade Club stays right here for you.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {PARTNERS.map((p) => (
          <a
            key={p.slug}
            href={partnerOutUrl(p)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`we-love-card-${p.slug}`}
            className="group relative flex flex-col bg-white border border-neutral-200 rounded-3xl overflow-hidden hover:border-[#E8956B]/60 hover:shadow-[0_18px_44px_rgba(0,0,0,0.10)] hover:-translate-y-1 transition-all duration-300"
          >
            <div className="relative aspect-square bg-white flex items-center justify-center p-8">
              <img
                src={p.logo}
                alt={`${p.name} logo`}
                className="max-h-full max-w-full object-contain group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-6 border-t border-neutral-100">
              <div className="flex items-center justify-between">
                <h2 className="font-display text-xl font-bold text-neutral-900">{p.name}</h2>
                <ExternalLink size={18} className="text-neutral-400 group-hover:text-[#E8956B] transition-colors" />
              </div>
              {p.tagline && (
                <p className="mt-1 text-sm font-semibold text-[#E8956B]">{p.tagline}</p>
              )}
              {p.blurb && <p className="mt-2 text-sm text-neutral-500 leading-relaxed">{p.blurb}</p>}
              <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-bold text-neutral-900 group-hover:gap-2.5 transition-all">
                Visit site <ExternalLink size={14} />
              </span>
            </div>
          </a>
        ))}
      </div>

      <div className="mt-16 text-center">
        <div className="inline-flex items-center gap-2 text-neutral-400 text-sm">
          <Sparkles size={16} className="text-[#E8956B]" /> More favorites coming soon
        </div>
      </div>
    </div>
  );
}
